module.exports = "<router-outlet>\r\n\r\n</router-outlet>\r\n<bw-loading-component></bw-loading-component>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/bw.component.html
// module id = ../../../../../ng-src/app/bw.component.html
// module chunks = main